var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gridComponent)?_c(_vm.gridComponent,_vm._g({tag:"component",attrs:{"is-admin":_vm.$route.meta.showAdminFunctions}},_vm.$listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }